import {
    GET_LAB_ORDERS,
    SET_LAB_ACTIVE_TILE,
    GET_PHARMACY_ORDERS,
    SET_PHARMACY_ACTIVE_TILE,
    READY_PHARMACY_ORDER
} from "../actions/dashboard";
const initialState = {
    lab_orders_waiting : false,
    lab_orders_success : {},
    lab_orders_error :{},
    lab_active_tile : 'waiting_for_price',
    pharmacy_orders_waiting : false,
    pharmacy_orders_success : {},
    pharmacy_orders_error :{},
    pharmacy_active_tile : 'vendor_assigned',
    ready_pharmacy_order_waiting : false,
    ready_pharmacy_order_success : {},
    ready_pharmacy_order_error :{},
}

export default function dashboard(state = initialState, action){
    switch (action.type){
        case GET_LAB_ORDERS:
            return {
                ...state,
                lab_orders_waiting : action.lab_orders_waiting,
                lab_orders_success : action.lab_orders_response,
                lab_orders_error : action.lab_orders_error
            }
        case SET_LAB_ACTIVE_TILE:
            return {
                ...state,
                lab_active_tile : action.lab_active_tile,
            }
        case GET_PHARMACY_ORDERS:
            return {
                ...state,
                pharmacy_orders_waiting : action.pharmacy_orders_waiting,
                pharmacy_orders_success : action.pharmacy_orders_response,
                pharmacy_orders_error : action.pharmacy_orders_error
            }
        case SET_PHARMACY_ACTIVE_TILE:
            return {
                ...state,
                pharmacy_active_tile : action.pharmacy_active_tile,
            }
        case READY_PHARMACY_ORDER:
            return {
                ...state,
                ready_pharmacy_order_waiting : action.ready_pharmacy_order_waiting,
                ready_pharmacy_order_success : action.ready_pharmacy_order_response,
                ready_pharmacy_order_error : action.ready_pharmacy_order_error
            }
        default:
            return state;
    }
}